import { render, staticRenderFns } from "./EventStatsContent.vue?vue&type=template&id=72a1dc7e"
import script from "./EventStatsContent.vue?vue&type=script&lang=js"
export * from "./EventStatsContent.vue?vue&type=script&lang=js"
import style0 from "./EventStatsContent.vue?vue&type=style&index=0&id=72a1dc7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports